var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-3",attrs:{"icon":"","color":_vm.color,"large":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("arrow_back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }